import { Campus } from '@/modules/core/data/types/Campus';
import { EducationalProgram } from '@/modules/core/data/types/EducationalProgram';
import { EducationalProgramStep } from '@/modules/core/data/types/EducationalProgramStep';
import { StudentSolutionsCategory } from '@/modules/core/data/types/StudentSolutionsCategory';

export const CHATBOT_CUSTOMER_KEY = 'customer';
export const CHATBOT_PERSONA_KEY = 'persona';
export const CHATBOT_EDUCATIONAL_PROGRAMS_KEY = 'educationalPrograms';
export const CHATBOT_EDUCATIONAL_PROGRAM_STEPS_KEY = 'educationalProgramSteps';
export const CHATBOT_CAMPUSES_KEY = 'campuses';
export const CHATBOT_CATEGORIES_KEY = 'categories';

/**
 * User context used in the chatbot.
 *
 * Similar to StudentSolutionContext, but only contains part of the data (ref, label) instead of whole objects.
 */
export type ChatbotContext = {
  [CHATBOT_CUSTOMER_KEY]?: {
    ref: string;
  };
  [CHATBOT_PERSONA_KEY]?: string;
  [CHATBOT_EDUCATIONAL_PROGRAMS_KEY]?: Pick<EducationalProgram, 'ref' | 'label'>[]; // Only allow one item even though it's an array
  [CHATBOT_EDUCATIONAL_PROGRAM_STEPS_KEY]?: Pick<EducationalProgramStep, 'ref' | 'label'>[]; // Only allow one item even though it's an array
  [CHATBOT_CAMPUSES_KEY]?: Pick<Campus, 'ref' | 'label'>[]; // Only allow one item even though it's an array
  [CHATBOT_CATEGORIES_KEY]?: Pick<StudentSolutionsCategory, 'ref' | 'label'>[]; // Only allow one item even though it's an array
}
